// extracted by mini-css-extract-plugin
export default {"loader":"UpcomingBookings_loader__R+bTt","h1":"UpcomingBookings_h1__DKMAs","wishlist":"UpcomingBookings_wishlist__0kIfR","wishlist1":"UpcomingBookings_wishlist1__ZYINC"};